<template>
  <v-form ref="stepOwnerRef">
    <v-row no-gutters>
      <v-col cols="12" md="6">
        <h3 class="mb-4">
          Typ
        </h3>
        <v-radio-group v-model="formOwnerStore.ownerType" :rules="mandatoryBoolean" inline>
          <v-radio label="Eigentümer" :value="true" />
          <v-radio label="Verwalter" :value="false" />
        </v-radio-group>
        <household-basic-information
          v-model="formOwnerStore.household"
          class="pt-0"
          required
          with-company-option
          :stakeholder="basicInformationStakeholder"
          :title="basicInformationTitle"
        />
        <v-divider class="py-4" />
        <h3 class="mb-4">
          Adresse
        </h3>
        <v-checkbox
          v-model="formOwnerStore.addressIsConnectionAddress"
          label="Eigentümer wohnt an Anschlussadresse"
          hide-details
        />
        <h3 v-if="formOwnerStore.addressIsConnectionAddress" class="ml-4">
          {{ orderStore.ordererAddress }}
        </h3>
        <address-form
          v-else
          v-model="formOwnerStore.address"
          required
        />
      </v-col>
    </v-row>
  </v-form>
</template>
<script setup lang="ts">
import { ref, computed } from 'vue';
import { mandatoryBoolean } from '../composables/validations';
import AddressForm from './common/address-form.vue';
import HouseholdBasicInformation from './common/household-basic-information.vue';
import useFormOwnerStore from '../store/form-owner';
import useOrderStore from '../store/order';

const formOwnerStore = useFormOwnerStore();
const orderStore = useOrderStore();

const stepOwnerRef = ref();

const basicInformationTitle = computed(() => (formOwnerStore.stepData.isOwner ? 'Eigentümer angeben' : 'Verwalter angeben'));
const basicInformationStakeholder = computed(() => (formOwnerStore.stepData.isOwner ? 'Eigentümer' : 'Verwalter'));

const isValid = async () => {
  const { valid } = await stepOwnerRef.value.validate();
  return valid;
};

defineExpose({
  applyData: () => {
    orderStore.addOwnerData(formOwnerStore.stepData);
  },
  isValid,
});
</script>
